"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>MicIcon
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
function MicIcon({ width = '44' }) {
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("svg", {
        width: `${width}`,
        height: "44",
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("rect", {
                width: "44",
                height: "44",
                rx: "22",
                fill: "url(#paint0_linear_0_2383)"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("rect", {
                width: "44",
                height: "44",
                rx: "22",
                fill: "url(#paint1_radial_0_2383)",
                fillOpacity: "0.7"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("rect", {
                width: "44",
                height: "44",
                rx: "22",
                fill: "url(#paint2_radial_0_2383)",
                fillOpacity: "0.3"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                d: "M22 24C21.1667 24 20.4583 23.7083 19.875 23.125C19.2917 22.5417 19 21.8333 19 21V15C19 14.1667 19.2917 13.4583 19.875 12.875C20.4583 12.2917 21.1667 12 22 12C22.8333 12 23.5417 12.2917 24.125 12.875C24.7083 13.4583 25 14.1667 25 15V21C25 21.8333 24.7083 22.5417 24.125 23.125C23.5417 23.7083 22.8333 24 22 24ZM21 31V27.925C19.2667 27.6917 17.8333 26.9167 16.7 25.6C15.5667 24.2833 15 22.75 15 21H17C17 22.3833 17.4875 23.5625 18.4625 24.5375C19.4375 25.5125 20.6167 26 22 26C23.3833 26 24.5625 25.5125 25.5375 24.5375C26.5125 23.5625 27 22.3833 27 21H29C29 22.75 28.4333 24.2833 27.3 25.6C26.1667 26.9167 24.7333 27.6917 23 27.925V31H21ZM22 22C22.2833 22 22.5208 21.9042 22.7125 21.7125C22.9042 21.5208 23 21.2833 23 21V15C23 14.7167 22.9042 14.4792 22.7125 14.2875C22.5208 14.0958 22.2833 14 22 14C21.7167 14 21.4792 14.0958 21.2875 14.2875C21.0958 14.4792 21 14.7167 21 15V21C21 21.2833 21.0958 21.5208 21.2875 21.7125C21.4792 21.9042 21.7167 22 22 22Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("linearGradient", {
                        id: "paint0_linear_0_2383",
                        x1: "5.53642",
                        y1: "5.58586",
                        x2: "38.0021",
                        y2: "35.6535",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                stopColor: "#7701BB"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.0745527",
                                stopColor: "#7601BB"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.146751",
                                stopColor: "#7503BC"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.216879",
                                stopColor: "#7205BD"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.285219",
                                stopColor: "#6E09BF"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.352055",
                                stopColor: "#690DC1"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.41767",
                                stopColor: "#6312C4"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.482348",
                                stopColor: "#5C18C7"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.54637",
                                stopColor: "#541FCA"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.610022",
                                stopColor: "#4C27CE"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.673586",
                                stopColor: "#422FD2"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.737345",
                                stopColor: "#3738D7"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.801582",
                                stopColor: "#2C42DC"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.866582",
                                stopColor: "#204DE1"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.932627",
                                stopColor: "#1358E7"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0564ED"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("radialGradient", {
                        id: "paint1_radial_0_2383",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(6.4106 2.35194) rotate(74.8737) scale(20.0999 49.1709)",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                stopColor: "#F5EBFA"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.161458",
                                stopColor: "#EEDEF6",
                                stopOpacity: "0.864583"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.333333",
                                stopColor: "#E8D2F3",
                                stopOpacity: "0.735701"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.661458",
                                stopColor: "#D1A8E8",
                                stopOpacity: "0.290563"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.822917",
                                stopColor: "#C999E4",
                                stopOpacity: "0.137944"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C28CE0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("radialGradient", {
                        id: "paint2_radial_0_2383",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(35.8411 39.395) rotate(-120.035) scale(12.2254 27.3643)",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                stopColor: "#E8F2FF"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "0.0001",
                                stopColor: "#E8F2FF"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("stop", {
                                offset: "1",
                                stopColor: "#99C3F9",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
